'use client'

import { IconSingle } from 'icons/components/IconSingle'
import { IconSquare02L } from 'icons/components/IconSquare02L'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { ColumnsNumber } from 'plp/types/Options'
import { ColumnLayout } from 'product-card/types'
import { applyStylesIf, cx } from 'utils/cx'

import styles from './Selector.module.scss'

export interface ColumnSelectorProps {
	columns: ColumnsNumber
	isCurrentTab: boolean
	handleClick: (newColumns: ColumnsNumber) => void
	isSmall: boolean
}

export function Selector({
	columns,
	isCurrentTab,
	isSmall,
	handleClick,
}: ColumnSelectorProps): React.ReactNode {
	const { t } = useLabels()

	const labels: { [x: number]: string } = {
		1: t('plp.view.columns.text'),
		2: t('accessibility.plp.two_columns'),
		4: t('accessibility.plp.four_columns'),
	}

	// TODO: Pending to design a middle way button-tabs component by UX
	/**
	 * Removed button disabled flag to keep visual consistency respect current production design
	 */
	return isSmall ? (
		<button
			aria-label={labels[columns] ?? undefined}
			type='button'
			className={cx(
				styles.columnSelector,
				applyStylesIf(isCurrentTab, styles.current)
			)}
			onClick={() => !isCurrentTab && handleClick(columns)}
		>
			{columns === ColumnLayout.OneColumn ? <IconSingle /> : <IconSquare02L />}
		</button>
	) : (
		<button
			data-testid={`column-selector-${columns}`}
			type='button'
			aria-label={labels[columns] ?? undefined}
			className={cx(
				styles.columnSelector,
				applyStylesIf(!isCurrentTab, styles.alternative)
			)}
			onClick={() => !isCurrentTab && handleClick(columns)}
		>
			{columns}
		</button>
	)
}
